import { combineReducers } from 'redux'
import loginReducer from './loginReducer'
import userReducer from './userReducer'
import categoriesReducer from './categoriesReducer'
import routeReducer from './routeReducer'
import menuReducer from './menuReducer'
import registerReducer from './registerReducer'
import articleReducer from './articleReducer'
import navigationReducer from './navigationReducer'

const rootReducers = combineReducers({
	article: articleReducer,
	navigation: navigationReducer,
	route: routeReducer,
	user: userReducer,
	login: loginReducer,	
	categories: categoriesReducer,	
	menu: menuReducer,
	register: registerReducer
})

export default rootReducers